/** @format */

import React from 'react';
import { Grid, MenuItem, InputAdornment } from '@material-ui/core';
import {
  BccTypography,
  BccCheckbox,
  BccInput,
  BccLink,
  BccSlider,
  BccButton,
  BccAlert,
  BccSnackbar,
  BccDialog,
  BccDialogActions,
  BccDialogContent,
  BccRadio,
  BccRadioGroup,
  BccFormControl,
  BccFormControlLabel,
} from './BccComponents';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import InputMask from 'react-input-mask';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import api from '../api/Api';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const cityList = [
  'Астана',
  'Алматы',
  'Шымкент',
  'Актау',
  'Актобе',
  'Атырау',
  'Жезказган',
  'Караганда',
  'Кокшетау',
  'Костанай',
  'Кызылорда',
  'Павлодар',
  'Петропавловск',
  'Семей',
  'Талдыкорган',
  'Тараз',
  'Уральск',
  'Усть-Каменогорск',
];
const cityListKz = [
  'Астана',
  'Алматы',
  'Шымкент',
  'Ақтау',
  'Ақтөбе',
  'Атырау',
  'Жезқазған',
  'Қарағанды',
  'Көкшетау',
  'Қостанай',
  'Қызылорда',
  'Павлодар',
  'Петропавл',
  'Семей',
  'Талдықорған',
  'Тараз',
  'Орал',
  'Өскемен',
];

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    [theme.breakpoints.between('md', 'xl')]: {
      outerContainer: {
        background: '#ffffff',
      },
      innerOrderForm: {},
      container: {
        maxWidth: 1280,
        margin: '0 auto',
        textAlign: 'center',
        boxSizing: 'border-box',
        padding: '48px 96px',
      },
      orderTitle: {
        width: '65%',
        margin: '0 auto',
      },
      orderNum: {
        color: '#249052',
        paddingRight: 10,
        borderRight: '.5px solid rgba(20, 20, 20, .7)',
      },
      orderNumTitle: {
        paddingLeft: 10,
        color: '#141414',
      },
      orderNumText: {
        marginTop: 20,
        opacity: 0.7,
      },
      item: {
        width: 'calc(33% - 20px)',
      },
      orderForm: {
        background: '#FFFFFF',
        boxShadow:
          '0px 0px 1px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 10px 20px rgba(0, 0, 0, 0.04)',
        borderRadius: 8,
        width: '60%',
        padding: 46,
        boxSizing: 'border-box',
        maxWidth: '60%',
        margin: '0 auto',
        textAlign: 'center',
      },
      titleForm: {
        marginBottom: 16,
      },
      subTitleForm: {
        marginBottom: 46,
        opacity: 0.7,
      },
      inputStyle: {
        marginBottom: 24,
        textAlign: 'left',
        maxWidth: 'inherit',
        '& > div > div': {
          whiteSpace: 'initial',
        },
      },
      inputStyleText: {
        textAlign: 'left',
        marginBottom: 32,
      },
      checkboxText: {
        alignItems: 'left',
        marginBottom: 24,
        textAlign: 'left',
      },
      btnWrap: {
        width: 'calc(50% - 10px)',
        '& > button': { width: '100%' },
      },
      icon: {
        width: '18px',
        height: '19px',
      },
      progress: {
        backgroundColor: '#E0E0E0',
        height: 36,
        borderRadius: 4,
        marginBottom: 24,
        textAlign: 'center',
        '& > span': {
          lineHeight: '36px',
        },
      },
      alert: {
        marginBottom: 32,
      },
      garant: { textAlign: 'left' },
      orderSteps: {
        marginBottom: 48,
        boxSizing: 'border-box',
        '& > div:first-child': {
          '& > div:first-child': {
            marginLeft: 'calc(33% / 2 - 20px)',
          },
          '& > div:nth-child(2n+1)': {
            height: 40,
            width: 40,
            borderRadius: '50%',
            backgroundColor: '#F3F3F3',
            textAlign: 'center',
            '& > span': {
              lineHeight: '40px',
            },
          },
          '& > div:nth-child(2n)': {
            width: 'calc(33% - 48px - 40px)',
            height: 1,
            backgroundColor: '#CCCFD1',
            margin: '20px 24px',
          },
        },
        '& > div:last-child': {
          marginTop: 12,
          '& > div': {
            width: '33%',
          },
        },
      },
      code: {
        margin: 0,
        '& input': {
          height: 62,
          boxSizing: 'border-box',
        },
      },
      timer: {
        fontSize: 16,
        color: '#4D565F',
      },
      docForm: {
        border: '1px solid #F3F3F3',
        borderRadius: 4,
        marginBottom: 24,
        padding: '12px',
        lineHeight: '48px',
        '& > div:first-child': {
          textAlign: 'left',
          width: '60%',
        },
      },
      hintText: {
        marginBottom: 24,
        padding: '8px 14px',
      },
      linkReSendSms: {
        color: '#3F0259',
        fontSize: 16,
        height: 'auto',
        padding: 0,
        lineHeight: 'initial',
        cursor: 'pointer',
        textTransform: 'none',
        '&:hover, &:active': {
          textDecoration: 'underline',
          opacity: 0.8,
        },
      },
      progressBarSuccess: {
        borderRadius: 5,
        display: 'block',
        margin: '12px 0 32px',
        height: 36,
        lineHeight: '36px',
        textAlign: 'center',
        position: 'relative',
        fontSize: 16,
        '& > span': {
          zIndex: 5,
          color: 'white',
          fontWeight: 'bold',
          position: 'relative',
        },
      },
      successForm: {
        backgroundColor: 'rgba(125, 206, 160, 0.1)',
        borderRadius: 8,
        textAlign: 'center',
        padding: '56px 64px 112px',
        '& > img': {
          display: 'block',
          margin: '0 auto',
          marginBottom: 24,
        },
      },
      errorForm: {
        backgroundColor: 'rgba(200, 79, 79, 0.1)',
        textAlign: 'center',
        borderRadius: 8,
        padding: '56px 64px 112px',
        '& > img': {
          display: 'block',
          margin: '0 auto',
          marginBottom: 24,
        },
      },
      progressBarInnerSuccess: {
        position: 'absolute',
        background: '#27AE60',
        transition: 'width .5s ease-out',
        top: 0,
        height: 36,
        borderRadius: 5,
        bottom: 0,
        zIndex: 4,
      },
      paymentWrap: {
        position: 'relative',
        marginBottom: 40,
      },
      sliderWrap: {
        position: 'relative',
        width: '100%',
      },
      input: {
        display: 'block',
        width: '100%',
        '& > div': {
          width: 'inherit',
        },
      },
      sliderRange: {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: -20,
        color: '#b3b6ba',
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 12,
      },
      btnStyle: {
        minWidth: 150,
        '& > span': {
          lineHeight: 'normal',
        },
      },
    },
    [theme.breakpoints.down('sm')]: {
      outerContainer: {
        background: '#ffffff',
      },
      innerOrderForm: {},
      container: {
        maxWidth: 1280,
        margin: '0 auto',
        textAlign: 'center',
        boxSizing: 'border-box',
        padding: '24px 48px',
      },
      orderTitle: {
        width: '90%',
        margin: '0 auto',
      },
      orderNum: {
        color: '#249052',
        paddingRight: 10,
        borderRight: '.5px solid rgba(20, 20, 20, .7)',
      },
      orderNumTitle: {
        paddingLeft: 10,
        color: '#141414',
      },
      orderNumText: {
        marginTop: 20,
        opacity: 0.7,
      },
      item: {
        width: 'calc(33% - 20px)',
      },
      orderForm: {
        background: '#FFFFFF',
        boxShadow:
          '0px 0px 1px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 10px 20px rgba(0, 0, 0, 0.04)',
        borderRadius: 8,
        width: '90%',
        padding: 46,
        boxSizing: 'border-box',
        maxWidth: '90%',
        margin: '0 auto',
        textAlign: 'left',
      },
      titleForm: {
        marginBottom: 16,
      },
      subTitleForm: {
        marginBottom: 46,
        opacity: 0.7,
      },
      inputStyle: {
        marginBottom: 24,
        textAlign: 'left',
        maxWidth: 'inherit',
        '& > div > div': {
          whiteSpace: 'initial',
        },
      },
      inputStyleText: {
        textAlign: 'left',
        marginBottom: 32,
      },
      checkboxText: {
        alignItems: 'left',
        marginBottom: 12,
      },
      btnWrap: {
        width: '100%',
        '& > button': { width: '100%' },
      },
      icon: {
        width: '18px',
        height: '19px',
      },
      progress: {
        backgroundColor: '#E0E0E0',
        height: 36,
        borderRadius: 4,
        marginBottom: 24,
        textAlign: 'center',
        '& > span': {
          lineHeight: '36px',
        },
      },
      alert: {
        marginBottom: 32,
      },
      garant: { textAlign: 'left', width: '100%', marginBottom: 12 },
      orderSteps: {
        marginBottom: 48,
        boxSizing: 'border-box',
        '& > div:first-child': {
          '& > div:first-child': {
            marginLeft: 'calc(33% / 2 - 20px)',
          },
          '& > div:nth-child(2n+1)': {
            height: 40,
            width: 40,
            borderRadius: '50%',
            backgroundColor: '#F3F3F3',
            textAlign: 'center',
            '& > span': {
              lineHeight: '40px',
            },
          },
          '& > div:nth-child(2n)': {
            width: 'calc(33% - 48px - 40px)',
            height: 1,
            backgroundColor: '#CCCFD1',
            margin: '20px 24px',
          },
        },
        '& > div:last-child': {
          marginTop: 12,
          '& > div': {
            width: '33%',
          },
        },
      },
      code: {
        margin: 0,
        '& input': {
          height: 62,
          boxSizing: 'border-box',
        },
      },
      timer: {
        fontSize: 16,
        color: '#4D565F',
      },
      docForm: {
        border: '1px solid #F3F3F3',
        borderRadius: 4,
        marginBottom: 24,
        padding: 12,
        lineHeight: '48px',
        '& > div:first-child': {
          textAlign: 'left',
          width: '60%',
        },
      },
      hintText: {
        marginBottom: 24,
        padding: '8px 14px',
      },
      linkReSendSms: {
        color: '#3F0259',
        fontSize: 16,
        height: 'auto',
        padding: 0,
        lineHeight: 'initial',
        cursor: 'pointer',
        textTransform: 'none',
        '&:hover, &:active': {
          textDecoration: 'underline',
          opacity: 0.8,
        },
      },
      progressBarSuccess: {
        borderRadius: 5,
        display: 'block',
        margin: '12px 0 32px',
        height: 36,
        lineHeight: '36px',
        textAlign: 'center',
        position: 'relative',
        fontSize: 16,
        '& > span': {
          zIndex: 5,
          color: 'white',
          fontWeight: 'bold',
          position: 'relative',
        },
      },
      successForm: {
        backgroundColor: 'rgba(125, 206, 160, 0.1)',
        borderRadius: 8,
        textAlign: 'center',
        padding: '56px 64px 112px',
        '& > img': {
          display: 'block',
          margin: '0 auto',
          marginBottom: 24,
        },
      },
      errorForm: {
        backgroundColor: 'rgba(200, 79, 79, 0.1)',
        textAlign: 'center',
        borderRadius: 8,
        padding: '56px 64px 112px',
        '& > img': {
          display: 'block',
          margin: '0 auto',
          marginBottom: 24,
        },
      },
      progressBarInnerSuccess: {
        position: 'absolute',
        background: '#27AE60',
        transition: 'width .5s ease-out',
        top: 0,
        height: 36,
        borderRadius: 5,
        bottom: 0,
        zIndex: 4,
      },
      paymentWrap: {
        position: 'relative',
        marginBottom: 40,
      },
      sliderWrap: {
        position: 'relative',
        width: '100%',
      },
      input: {
        display: 'block',
        width: '100%',
        '& > div': {
          width: 'inherit',
        },
      },
      sliderRange: {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: -20,
        color: '#b3b6ba',
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 12,
      },
      btnStyle: {
        minWidth: 150,
        '& > span': {
          lineHeight: 'normal',
        },
      },
    },
    [theme.breakpoints.down('xs')]: {
      orderTitle: {
        width: '100%',
        margin: '0 auto',
      },
      container: {
        maxWidth: 1280,
        margin: '0 auto',
        textAlign: 'center',
        boxSizing: 'border-box',
        padding: '24px',
      },
      orderForm: {
        width: '100%',
        maxWidth: '100%',
        padding: 24,
      },
    },
    radio: {
      marginBottom: 24,
      width: '100%',
    },
    reBtn: { marginTop: 12 },
    file: { opacity: 0, position: 'absolute', width: '100%', height: '100%' },
  })
);

interface TextMaskCustomProps {
  inputRef: (ref: HTMLInputElement | null) => void;
}

interface Loan {
  acc_id: string;
  acc_nickname: string;
  acc_nickname2: string;
  prod_type: string;
  // type_cli: "FIZ" | "IP";
}

const BccMaskedInput = (props: TextMaskCustomProps) => {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={(ref: any) => inputRef(ref ? ref.inputElement : null)}
      mask='+7(999) 999 99 99'
      maskChar=''
      placeholder={'+7(707) 707 77 77'}
    />
  );
};

const BccMaskedIinInput = (props: TextMaskCustomProps) => {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={(ref: any) => inputRef(ref ? ref.inputElement : null)}
      mask='999 999 999 999'
      maskChar=''
      placeholder={'000 000 000 000'}
    />
  );
};

const Order = (props: any) => {
  const classes = useStyles({});
  const [inputShow, setInputShow] = React.useState(false);
  const [increaseinloan, setIncreaseinLoan] = React.useState(false);
  const [type, setType] = React.useState('');
  const [subType, setSubType] = React.useState('');
  const [sloan, setSloan] = React.useState<string[]>([]);
  const [step, setStep] = React.useState(0);
  const [filial, setFilial] = React.useState('');
  const [iin, setIin] = React.useState('');
  const [iinMain, setIinMain] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [token, setToken] = React.useState('');
  const [phoneError, setPhoneError] = React.useState<boolean>(false);
  const [agree, setAgree] = React.useState<boolean>(true);
  const [agreeTarif, setAgreeTarif] = React.useState<boolean>(true);
  const [success, setSuccess] = React.useState<boolean>(false);
  const [isLoading, setLoading] = React.useState(false);
  const [other, setOther] = React.useState('');
  const [period, setPeriod] = React.useState('1');
  const [reason, setReason] = React.useState('');
  const [timer, setTimer] = React.useState(0);
  const [code, setCode] = React.useState('');
  const [file1, setFile1] = React.useState('');
  const [file1Error, setFile1Error] = React.useState(false);
  const [loans, setLoans] = React.useState<Loan[] | []>([]);
  const [agreeWp, setAgreeWp] = React.useState<boolean>(true);
  const [agreeThird, setAgreeThird] = React.useState<boolean>(false);
  const [wp, setWp] = React.useState<string>('');
  const [agreeFa, setAgreeFa] = React.useState<boolean>(false);
  const [openModal, setOpenModal] = React.useState(0);
  const [openModalState, setOpenModalState] = React.useState(false);
  const [openModal2, setOpenModal2] = React.useState(0);
  const [fa, setFa] = React.useState<string>('');
  const [type1num, setType1num] = React.useState<string>('');
  const [type1sum, setType1sum] = React.useState<string>('');
  const [type1date, setType1date] = React.useState<string>('');
  const [open, setOpen] = React.useState(false);
  const [openText, setOpenText] = React.useState('');
  const [openType, setOpenType] = React.useState('success');
  const [typeCli, setTypeCli] = React.useState('');
  const { t, i18n } = useTranslation();

  const reasons = [
    t('order.reason1'),
    t('order.reason2'),
    t('order.reason3'),
    t('order.reason4'),
    t('order.reason5'),
    t('order.reason6'),
  ];

  React.useEffect(() => {
    const now = moment();
    const day = now.date(); // 1-31
    const month = now.month() + 1; // 1-12
    const weekday = now.day(); // 0 (Sun) - 6 (Sat)
    const hour = now.hour(); // 0-23

    const HOLIDAYS = [
      '01-01',
      '02-01',
      '03-01',
      '07-01', // Январь
      '10-03',
      '21-03',
      '24-03',
      '25-03', // Март
      '16-12', // Декабрь
      '07-07',
      '01-09',
      '27-10', // Доп. выходные 2025
    ];

    const isHoliday = () => {
      const currentDate = `${String(day).padStart(2, '0')}-${String(month).padStart(2, '0')}`;
      return HOLIDAYS.includes(currentDate);
    };

    const isWeekend = weekday === 6 || (weekday === 0 && !(day === 5 && month === 1));

    const isOffHours = hour < 9 || hour >= 18;

    const isNewYearsEveMorning = day === 31 && month === 12 && hour >= 9 && hour < 16;
    const isNewYearsEveAfternoon = day === 31 && month === 12 && hour >= 16 && hour < 18;

    if (isNewYearsEveMorning) {
      setOpenModalState(true);
      setOpenModal(998);
    } else if (isNewYearsEveAfternoon) {
      setOpenModalState(true);
      setOpenModal(999);
    } else if (isOffHours || isHoliday() || isWeekend) {
      setOpenModalState(true);
      setOpenModal(99);
    }
  }, []);

  React.useEffect(() => {
    let timeOut = setInterval(() => {
      if (timer !== 0) {
        setTimer(timer - 1);
      }
    }, 1000);
    return () => clearInterval(timeOut);
  }, [timer]);

  const formatPhoneNumber = (phoneNumber: string) => {
    let res = phoneNumber;
    if (phoneNumber.slice(0, 1) === '8' || phoneNumber.slice(0, 1) === '7')
      res = '+7' + phoneNumber.slice(1);
    return res.replace(/\(|\)| /g, '');
  };

  const isValid = () => {
    if (step === 0) {
      const subtypeLength = getSubtype(type).length;
      if (!subType && subtypeLength > 0) {
        return false;
      }
      if (
        openModal === 14 ||
        openModal === 112 ||
        openModal === 5 ||
        openModal === 6 ||
        openModal === 11 ||
        openModal === 16 ||
        (openModal === 2 && type === '9') ||
        (openModal === 1 && type === '10') ||
        (type === '1' &&
          (openModal === 11 || openModal === 12 || openModal === 13 || openModal === 4))
      )
        return false;
      else if (type === '4' && !increaseinloan) {
        return false;
      }
      return (
        type !== '' &&
        filial !== '' &&
        iin.replace(/ /g, '').length === 12 &&
        phone.replace('_', '').length === 17 &&
        agree &&
        agreeTarif
      );
    } else if (step === 1) return code.length === 4;
    else if (step === 2) {
      if (type === '13' && file1.length < 1) {
        return false;
      }
      return type === '4'
        ? sloan.length > 0 &&
            +period > 0 &&
            reason.length > 0 &&
            ((agreeWp && wp.length > 0) || !agreeWp)
        : type === '1' && subType === '2'
        ? type1sum.length > 0 &&
          sloan.length > 0 &&
          other.length > 0 &&
          ((agreeWp && wp.length > 0) || !agreeWp) &&
          ((agreeFa && fa.length > 0) || !agreeFa) &&
          ((agreeThird && iinMain.length > 0) || !agreeThird)
        : type === '1' && (subType === '3' || subType === '4')
        ? type1date.length > 0 &&
          sloan.length > 0 &&
          other.length > 0 &&
          ((agreeWp && wp.length > 0) || !agreeWp) &&
          ((agreeFa && fa.length > 0) || !agreeFa) &&
          ((agreeThird && iinMain.length > 0) || !agreeThird)
        : sloan.length > 0 &&
          other.length > 0 &&
          ((agreeWp && wp.length > 0) || !agreeWp) &&
          ((agreeFa && fa.length > 0) || !agreeFa) &&
          ((agreeThird && iinMain.length > 0) || !agreeThird);
    } else return true;
  };

  const generateJSON = () => {
    const JSONS = {
      WebDataItem: [
        {
          Name: 'IINS',
          Value: iin.replace(/ /g, ''),
        },
        {
          Name: 'Surname',
          Value: '',
        },
        {
          Name: 'Name',
          Value: '',
        },
        {
          Name: 'MiddleName',
          Value: '',
        },
        {
          Name: 'Branch',
          Value: filial,
        },
        {
          Name: 'DeferralRequiredNumber',
          Value: sloan.filter((s) => s === '-1').length > 0 ? '' : sloan.map((s) => s).join(', '),
        },
        {
          Name: 'DelayPeriod',
          Value: type === '4' ? period : '',
        },
        {
          Name: 'DelayReason',
          Value: `${t(`order.type`)}: ${t(`order.type${type}`)}. ${
            subType !== '' ? `${t(`order.subtype`)}: ${t(`order.subtype${type}${subType}`)}. ` : ''
          }${reason !== '' ? `${t(`order.reason`)}: ${reason}. ` : ''}${
            other !== '' ? `${t(`order.text`)}: ${other}. ` : ''
          }${fa !== '' ? `${t(`order.type13`)}: ${fa}. ` : ''}${
            type1num !== '' ? `${t(`order.type14`)}: ${type1num}. ` : ''
          }${type1sum !== '' ? `${t(`order.type16`)}: ${type1sum}. ` : ''}${
            type1date !== '' ? `${t(`order.type15`)}: ${type1date}.` : ''
          }`,
        },
        {
          Name: 'PhoneNumber',
          Value: formatPhoneNumber(phone),
        },
        {
          Name: 'EMail',
          Value: wp,
        },
        {
          Name: 'StatementType',
          Value: type,
        },
        {
          Name: 'DPType',
          Value: subType === '' ? type : type + '.' + subType,
        },
        {
          Name: 'FactAddress',
          Value: fa,
        },
        {
          Name: 'AccountNumber',
          Value: type1num,
        },
        {
          Name: 'PayDate',
          Value: type1date,
        },
        {
          Name: 'CHDPSum',
          Value: type1sum,
        },
        {
          Name: 'IINZ',
          Value: iinMain,
        },
        {
          Name: 'Base64',
          DataArray: {
            WebData: [
              {
                Items: [
                  {
                    Name: 'AddFiles',
                    Value: file1,
                  },
                ],
              },
            ],
          },
        },
      ],
    };
    return JSONS;
  };
  const startProcess = () => {
    setLoading(true);
    api.camunda
      .start(generateJSON(), token)
      .then((r: any) => {
        if (r && r.success) {
          setSuccess(true);
          setStep(3);
          props.scrollToOrder(false);
          setLoading(false);
        }
      })
      .catch((e: any) => {
        console.error(e);
        setLoading(false);
      });
  };

  const getOtp = () => {
    setLoading(true);
    setTimer(60);
    api.authOtp
      .sendOtp({
        phone: formatPhoneNumber(phone),
        iin,
      })
      .then((res) => {
        if (res.success) {
          if (res.access_token) {
            setToken(`${res.token_type} ${res.access_token}`);
            setStep(1);
            props.scrollToOrder(false);
            setLoading(false);
          }
        }
      })
      .catch((e: any) => {
        setOpenType('error');
        setOpenText(t('order.phoneReqError'));
        setOpen(true);
        console.error(e.result);
        props.scrollToOrder(false);
        setLoading(false);
      });
  };

  const onSubmitOtp = () => {
    setLoading(true);
    api.authOtp
      .confirmOtp(code, token)
      .then((res) => {
        if (res.success) {
          if (res.loanInfo) setLoans([...res.loanInfo]);
          props.scrollToOrder(false);
          setLoading(false);
          setStep(2);
        }
      })
      .catch((e: any) => {
        setOpenType('error');
        setOpenText(t('order.codeError'));
        setOpen(true);
        props.scrollToOrder(false);
        console.error(e);
        setLoading(false);
      });
  };

  const successAlert = () => {
    setOpenType('success');
    setOpenText(t('order.docUpload'));
    setOpen(true);
  };

  const handleChange = (e: any, num: number) => {
    const files = e.target.files;
    const file = files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let res = reader.result as string;
      res = res.split(',')[1];
      if (num === 0) {
        if (file.size > 5000000) {
          setFile1Error(true);
        } else {
          setFile1(res);
          setFile1Error(false);
          successAlert();
        }
      }
    };
  };

  const getSubtype = (type: string) => {
    if (type === '1') return ['1', '2', '3', '4'];
    else if (type === '2') return ['1', '2'];
    else if (type === '3') return ['1', '2'];
    else if (type === '8') return ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
    else if (type === '9') return ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
    else if (type === '10') return ['1', '2', '3'];
    else if (type === '12') return ['1', '2', '3'];
    else if (type === '13') return ['1', '2'];
    else return [];
  };

  const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <div className={classes.outerContainer} ref={props.refProp}>
      <div className={classes.container}>
        <div className={classes.orderTitle}>
          <BccTypography type='h3' weight='medium' block mb='16px'>
            {t('order.title')}
          </BccTypography>
          <BccTypography type='p1' block color='#4D565F' mb='48px'>
            {t('order.subtitle')}
          </BccTypography>
          <Grid container direction='column' justify='center' className={classes.orderSteps}>
            <Grid item container direction='row'>
              <Grid item>
                <BccTypography type='h5'>1</BccTypography>
              </Grid>
              <Grid item></Grid>
              <Grid item>
                <BccTypography type='h5'>2</BccTypography>
              </Grid>
              <Grid item></Grid>
              <Grid item>
                <BccTypography type='h5'>3</BccTypography>
              </Grid>
            </Grid>
            <Grid item container direction='row' justify='center'>
              <Grid item>
                <BccTypography type='p2' weight='medium' block mb='8px'>
                  {t('order.1')}
                </BccTypography>
                <BccTypography type='p3' block color='#4D565F'>
                  {t('order.11')}
                </BccTypography>
              </Grid>
              <Grid item>
                <BccTypography type='p2' weight='medium' block mb='8px'>
                  {t('order.2')}
                </BccTypography>
                <BccTypography type='p3' block color='#4D565F'>
                  {t('order.22')}
                </BccTypography>
              </Grid>
              <Grid item>
                <BccTypography type='p2' weight='medium' block mb='8px'>
                  {t('order.3')}
                </BccTypography>
                <BccTypography type='p3' block color='#4D565F'>
                  {t('order.33')}
                </BccTypography>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <BccSnackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={open}
          autoHideDuration={10000}
          onClose={handleClose}
        >
          <BccAlert severity={openType} onClose={handleClose}>
            {openText}
          </BccAlert>
        </BccSnackbar>
        <BccDialog
          onClose={() =>
            openModal !== 99 && openModal !== 999 && openModal !== 1111 && setOpenModalState(false)
          }
          aria-labelledby='customized-dialog-title'
          open={openModalState}
        >
          <BccDialogContent>
            <BccTypography type='p1'>
              {openModal === 1 ? (
                t('order.ipotekaNotif')
              ) : openModal === 2 ? (
                t('order.agreeNotif')
              ) : openModal === 3 ? (
                <>
                  {t('order.modal')}
                  <BccLink
                    className={classes.headerLink}
                    href='https://onelink.to/t8f6vy'
                    target='_blank'
                  >
                    BCC.KZ
                  </BccLink>
                  {t('order.modal2')}
                  {'. '}
                  <BccLink
                    className={classes.headerLink}
                    href={process.env.PUBLIC_URL + '/date.mp4'}
                    target='_blank'
                  >
                    {t('order.instruction')}
                  </BccLink>
                </>
              ) : openModal === 11 || openModal === 4 ? (
                <>
                  {t('order.tarifNotif11')}
                  <a href='https://bcc-kz.onelink.me/DHqP/4a2103hk'>{t('order.linkForDownload')}</a>
                </>
              ) : openModal == 112 ? (
                <>{t('order.tarifNotif112')}</>
              ) : openModal == 5 ? (
                <>
                  {t('order.tarifNotif5')}
                  <a href='https://api.whatsapp.com/send/?phone=77471111505&text&type=phone_number&app_absent=0'>
                    {t('order.WhatsApp')}
                  </a>
                  {t('order.or')}
                  <a href='https://t.me/BankCenterCredit_bot'>{t('order.Telegram')}</a>
                  {t('order.tarifNotif5Ending')}
                </>
              ) : openModal === 1111 ? (
                t('order.tarifNotif1111')
              ) : openModal === 12 ? (
                t('order.tarifNotif12')
              ) : openModal === 13 ? (
                t('order.tarifNotif13')
              ) : openModal === 16 ? (
                <>
                  {t('order.tarifNotif16')}{' '}
                  <a href='https://bcc-kz.onelink.me/DHqP/4a2103hk'>{t('order.linkForDownload')}</a>
                </>
              ) : openModal === 14 ? (
                t('order.tarifNotif11')
              ) : openModal === 15 ? (
                t('order.tarifNotif14')
              ) : openModal === 99 ? (
                t('tab.text99')
              ) : openModal === 998 ? (
                <>
                  {t('tab.text998')}
                  <br />
                  {t('tab.text9981')}
                </>
              ) : openModal === 999 ? (
                <>
                  {t('tab.text999')}
                  <br />
                  {t('tab.text9981')}
                </>
              ) : (
                ''
              )}
            </BccTypography>
          </BccDialogContent>
          <BccDialogActions>
            {openModal === 3
              ? t('order.continue')
              : openModal === 15
              ? t('order.tarifNotif141')
              : ''}
            {openModal !== 12 &&
            openModal !== 13 &&
            openModal !== 11 &&
            openModal !== 4 &&
            openModal !== 16 &&
            (openModal === 998 ||
              (openModal !== 999 &&
                openModal !== 14 &&
                openModal !== 99 &&
                openModal !== 1111 &&
                openModal !== 112 &&
                openModal !== 5)) ? (
              <BccButton
                autoFocus
                onClick={() => setOpenModalState(false)}
                variant='contained'
                size='small'
                color='primary'
                style={{ marginLeft: 4 }}
              >
                {t('order.next')}
              </BccButton>
            ) : (
              ''
            )}
          </BccDialogActions>
        </BccDialog>

        <BccDialog
          onClose={() => setOpenModal2(0)}
          aria-labelledby='customized-dialog-title'
          open={openModal2}
        >
          <BccDialogContent>
            <p style={{ whiteSpace: 'pre-wrap' }}>{t('modal2.text')}</p>
          </BccDialogContent>
          <BccDialogActions>
            <BccButton
              autoFocus
              onClick={() => setOpenModal2(0)}
              variant='contained'
              size='small'
              color='primary'
            >
              {t('order.next')}
            </BccButton>
          </BccDialogActions>
        </BccDialog>

        <div className={classes.orderForm}>
          <Grid direction='column' container className={classes.innerOrderForm}>
            <Grid item style={{ display: step === 3 ? 'none' : 'block' }}>
              <BccTypography type='p2' block color='#4D565F' mb='12px' align='left'>
                {step + 1 === 1
                  ? t('order.step1')
                  : step + 1 === 2
                  ? t('order.step2')
                  : t('order.step3')}
              </BccTypography>
              <div className={classes.progress}>
                <div className={classes.progressBarSuccess}>
                  <BccTypography type='p2' color={`${step * 33 > 33 ? 'white' : 'black'}`}>
                    {step * 33 + ' %'}
                  </BccTypography>
                  <div
                    style={{ width: `${step * 33 + '%'}` }}
                    className={classes.progressBarInnerSuccess}
                  ></div>
                </div>
              </div>
            </Grid>

            <BlockUi tag='div' blocking={isLoading}>
              {step === 0 ? (
                <>
                  <Grid item style={{ marginBottom: 24 }}>
                    <BccAlert severity='error'>
                      <BccTypography type='p3' align='left'>
                        {t('order.notice')}
                      </BccTypography>
                    </BccAlert>
                  </Grid>
                  <Grid item>
                    <BccInput
                      fullWidth={true}
                      className={classes.inputStyle}
                      label={t('order.type') + '*'}
                      id='type'
                      name='type'
                      value={type}
                      onChange={(e: any) => {
                        setType(e.target.value);
                        setSubType('');
                        if (e.target.value === '11') {
                          setOpenModal(15);
                          setOpenModalState(true);
                        } else if (
                          e.target.value === '4' ||
                          e.target.value === '6' ||
                          e.target.value === '8' ||
                          e.target.value === '9' ||
                          e.target.value === '10'
                        ) {
                          setInputShow(true);
                          setOpenModal(11);
                          setOpenModalState(true);
                        } else if (e.target.value === '13') {
                          setOpenModal(16);
                          setOpenModalState(true);
                        } else if (e.target.value === '12') {
                          setOpenModal(112);
                          setOpenModalState(true);
                        } else if (e.target.value === '5') {
                          setOpenModal(5);
                          setOpenModalState(true);
                        } else {
                          setInputShow(false);
                          setOpenModal(0);
                        }
                      }}
                      variant='outlined'
                      select
                    >
                      <MenuItem key='' value=''></MenuItem>
                      {['1', '2', '3', '4', '5', '6', '8', '9', '10', '12', '13'].map(
                        (ty: string) => (
                          <MenuItem key={ty} value={ty}>
                            {t(`order.type${ty}`)}
                          </MenuItem>
                        )
                      )}
                    </BccInput>
                  </Grid>
                  {getSubtype(type).length > 0 && (
                    <Grid item>
                      <BccInput
                        fullWidth={true}
                        className={classes.inputStyle}
                        label={t('order.subtype') + '*'}
                        id='subtype'
                        name='subtype'
                        value={subType}
                        onChange={(e: any) => {
                          if (type === '1' && e.target.value === '1') {
                            setOpenModal(11);
                            setOpenModalState(true);
                          } else if (
                            (type === '3' && e.target.value === '1') ||
                            (type === '3' && e.target.value === '2')
                          ) {
                            setOpenModal(1111);
                            setOpenModalState(true);
                          } else if (type === '1' && e.target.value === '3') {
                            setOpenModal(12);
                            setOpenModalState(true);
                          } else if (type === '1' && e.target.value === '4') {
                            setOpenModal(13);
                            setOpenModalState(true);
                          } else if (
                            (type === '2' && e.target.value === '1') ||
                            (type === '2' && e.target.value === '2')
                          ) {
                            setOpenModal(14);
                            setOpenModalState(true);
                          } else if (type === '1' && e.target.value === '2') {
                            setOpenModal(4);
                            setOpenModalState(true);
                          } else if (type === '10' && e.target.value === '1') {
                            setOpenModal(1);
                            setOpenModalState(true);
                          } else if (type === '9' && e.target.value === '6') {
                            setOpenModal(2);
                            setOpenModalState(true);
                          }
                          setSubType(e.target.value);
                        }}
                        variant='outlined'
                        select
                      >
                        <MenuItem key='' value=''></MenuItem>
                        {getSubtype(type).map((sty: string) => (
                          <MenuItem key={sty} value={sty}>
                            {t(`order.subtype${type}${sty}`)}
                          </MenuItem>
                        ))}
                      </BccInput>
                    </Grid>
                  )}
                  <Grid item>
                    <BccInput
                      fullWidth={true}
                      className={classes.inputStyle}
                      label={t('order.branch') + '*'}
                      id='filial'
                      name='filial'
                      value={filial}
                      onChange={(e: any, i: any) => {
                        // let indx = Number(i.key.replace(/\D/g, ''));
                        // if([0, 1, 2, 3, 4, 6, 7, 10, 11, 13, 14, 15, 17].includes(indx)) {
                        //   console.log(indx,'indx')
                        //   setOpenModal(14);
                        //   setOpenModalState(true);
                        // }
                        setFilial(e.target.value);
                      }}
                      variant='outlined'
                      select
                    >
                      {props.lang === 'ru'
                        ? cityList.map((b: any, index: number) => {
                            return (
                              <MenuItem key={index} value={b}>
                                {b}
                              </MenuItem>
                            );
                          })
                        : cityListKz.map((b: any, index: number) => {
                            return (
                              <MenuItem key={index} value={b}>
                                {b}
                              </MenuItem>
                            );
                          })}
                    </BccInput>
                  </Grid>
                  <Grid item>
                    <BccInput
                      className={classes.inputStyle}
                      fullWidth
                      label={t('order.iin') + '*'}
                      variant='filled'
                      id='iin'
                      name='iin'
                      value={iin}
                      onChange={(e: any) => setIin(e.target.value.replace(/\D/g, '').substr(0, 12))}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputComponent: BccMaskedIinInput as any,
                      }}
                    />
                  </Grid>
                  {loans.length > 0 && (
                    // loans.filter((l: Loan) => l.type_cli === "FIZ").length > 0 &&
                    // loans.filter((l: Loan) => l.type_cli === "IP").length > 0 &&
                    <Grid item>
                      <BccFormControl className={classes.radio}>
                        <BccRadioGroup
                          value={typeCli}
                          row
                          onChange={(e: any) => {
                            setTypeCli(e.target.value);
                          }}
                        >
                          <BccFormControlLabel
                            value='FIZ'
                            control={<BccRadio disableRipple />}
                            label={t('order.fiz')}
                            labelPlacement='end'
                          />
                          <BccFormControlLabel
                            value='IP'
                            control={<BccRadio disableRipple />}
                            label={t('order.ip')}
                            labelPlacement='end'
                          />
                        </BccRadioGroup>
                      </BccFormControl>
                    </Grid>
                  )}
                  <Grid item>
                    <BccInput
                      variant='filled'
                      fullWidth
                      label={t('order.phone') + '*'}
                      onChange={(e: any) => setPhone(e.target.value)}
                      className={classes.inputStyle}
                      helperText={phoneError ? t('order.phoneError') : ''}
                      error={phoneError ? true : false}
                      id='phone'
                      name='phone'
                      value={phone}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputComponent: BccMaskedInput as any,
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <Grid
                      container
                      justify='flex-start'
                      wrap='nowrap'
                      className={classes.checkboxText}
                    >
                      <Grid item>
                        <BccCheckbox
                          value='remember'
                          color='primary'
                          checked={agree}
                          onChange={() => setAgree(!agree)}
                        />
                      </Grid>
                      <Grid item>
                        <BccTypography type='p3' ml='10px'>
                          {t('order.agree')}{' '}
                          <BccLink href={`https://bcc.kz/deferral/agreement.pdf`} target='_blank'>
                            {t('order.agree2')}
                          </BccLink>
                        </BccTypography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Grid
                      container
                      justify='flex-start'
                      wrap='nowrap'
                      className={classes.checkboxText}
                    >
                      <Grid item>
                        <BccCheckbox
                          value='remember'
                          color='primary'
                          checked={agreeTarif}
                          onChange={() => setAgreeTarif(!agreeTarif)}
                        />
                      </Grid>
                      <Grid item>
                        <BccTypography type='p3' ml='10px'>
                          {t('order.tarif')}{' '}
                          <BccLink href={`https://www.bcc.kz/fizical/tarify/`} target='_blank'>
                            {t('order.tarif1')}
                          </BccLink>{' '}
                          {t('order.tarif2')}
                        </BccTypography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Grid
                      container
                      justify='flex-start'
                      wrap='nowrap'
                      className={classes.checkboxText}
                      style={{ display: inputShow ? 'flex' : 'none' }}
                    >
                      <Grid item>
                        <BccCheckbox
                          disable={!increaseinloan}
                          value=''
                          color='primary'
                          checked={increaseinloan}
                          onChange={() => setIncreaseinLoan(!increaseinloan)}
                        />
                      </Grid>
                      <Grid item>
                        <BccTypography type='p3' ml='10px'>
                          {t('order.increaseinloan_text_1')}
                          <BccTypography
                            color={'#27AE60'}
                            type='p3'
                            onClick={() => setOpenModal2(1)}
                          >
                            {t('order.increaseinloan_text_2')}
                          </BccTypography>{' '}
                          {t('order.increaseinloan_text_3')}
                        </BccTypography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item>
                    <Grid container justify='space-between'>
                      <Grid item className={classes.btnWrap}>
                        <Grid container spacing={2}>
                          <Grid item>
                            <img
                              src={process.env.PUBLIC_URL + '/img/safety.svg'}
                              className={classes.icon}
                              alt='order_security'
                            />
                          </Grid>
                          <Grid item xl={true} lg={true} md={true} sm={true} xs={true}>
                            <BccTypography type='p3' className={classes.garant}>
                              {t('order.security')}
                            </BccTypography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item className={classes.btnWrap}>
                        <BccButton
                          variant='contained'
                          disabled={!isValid()}
                          color='primary'
                          onClick={() => getOtp()}
                        >
                          {t('order.next')}
                        </BccButton>
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              ) : step === 1 ? (
                <>
                  <Grid item container justify='space-between' alignItems='center' spacing={4}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <BccInput
                        variant='outlined'
                        className={classes.code}
                        margin='normal'
                        fullWidth
                        id='code'
                        name='code'
                        value={code}
                        onChange={(e: any) =>
                          setCode(e.target.value.replace(/\D/g, '').substr(0, 6))
                        }
                        label={t('order.code')}
                      />
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <BccButton
                        onClick={() => onSubmitOtp()}
                        variant='contained'
                        fullWidth
                        disabled={!isValid()}
                      >
                        {t('order.confirm')}
                      </BccButton>
                    </Grid>
                    {timer !== 0 ? (
                      <Grid item>
                        <BccTypography type='p3' className={classes.timer}>
                          {props.lang === 'ru'
                            ? `${t('order.resendFull')} 00:${timer}`
                            : `00:${timer} ${t('order.resendFull')}`}
                        </BccTypography>
                      </Grid>
                    ) : (
                      <Grid item>
                        <BccButton
                          variant='text'
                          className={classes.linkReSendSms}
                          onClick={() => getOtp()}
                        >
                          {t('order.resend')}
                        </BccButton>
                      </Grid>
                    )}
                  </Grid>
                </>
              ) : step === 2 ? (
                type === '4' ? (
                  <>
                    {loans.length === 0 && (
                      <Grid item style={{ marginBottom: 24 }}>
                        <BccAlert severity='error'>
                          <BccTypography type='p3' align='left'>
                            {t('order.notice4')}
                          </BccTypography>
                        </BccAlert>
                      </Grid>
                    )}
                    <Grid item>
                      <BccInput
                        fullWidth={true}
                        className={classes.inputStyle}
                        label={t('order.num')}
                        id='sloan'
                        name='sloan'
                        value={sloan.map((s) => s).join(', ')}
                        variant='outlined'
                        select
                        disabled={loans.length === 0}
                      >
                        <MenuItem key='0' value='0'></MenuItem>
                        {sloan.length > 1 && (
                          <MenuItem key='-2' value={sloan.map((s) => s).join(', ')}>
                            {sloan.map((s) => s).join(', ')}
                          </MenuItem>
                        )}
                        {(loans as Loan[])
                          // .filter((l: Loan) =>
                          //   typeCli.length > 0 ? l.type_cli === typeCli : true,
                          // )
                          .map((l: Loan, i: number) => (
                            <MenuItem
                              key={i}
                              value={l.acc_nickname2}
                              onClick={() =>
                                sloan.filter((s) => s === l.acc_nickname2).length > 0
                                  ? setSloan([...sloan.filter((s) => s !== l.acc_nickname2)])
                                  : setSloan([...sloan, l.acc_nickname2])
                              }
                            >
                              <BccCheckbox
                                value='remember'
                                color='primary'
                                checked={sloan.filter((s) => s === l.acc_nickname2).length > 0}
                              />
                              {`${l.acc_nickname} ${l.acc_nickname2}`}
                              {/* от ${l.loan_date} ${l.loan_name} ${l.loan_sum} KZT`}{" "} */}
                              {/* <span
                                style={{
                                  color: "#27AE60",
                                  margin: "0 0 0 20px",
                                }}
                              >
                                {l.loan_status}
                              </span> */}
                            </MenuItem>
                          ))}
                      </BccInput>
                    </Grid>
                    <Grid item>
                      <div className={classes.paymentWrap}>
                        <div className={classes.sliderWrap}>
                          <BccInput
                            label={t('order.period')}
                            key='period'
                            value={`${period} ${t('order.month')}`}
                            variant='filled'
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={(e: any) => {
                              const s = e.target.value.slice(-1).replace(/[^0-9]/g, '');
                              if (s > 6) setPeriod('6');
                              else setPeriod(s.toString());
                            }}
                            className={classes.input}
                          />
                          <BccSlider
                            style={{
                              left: 6,
                              right: 6,
                              width: 'calc(100% - 12px)',
                              bottom: -1,
                              padding: 0,
                              position: 'absolute',
                            }}
                            min={1}
                            max={6}
                            step={1}
                            value={period}
                            valueLabelDisplay='off'
                            defaultValue={period}
                            onChange={(e: any, val: any) =>
                              setPeriod(val instanceof Array ? val[1] : val)
                            }
                          />
                          <div className={classes.sliderRange}>
                            <span>1 {t('order.month')}</span>
                            <span>6 {t('order.month')}</span>
                          </div>
                        </div>
                      </div>
                    </Grid>
                    <Grid item>
                      <BccInput
                        fullWidth={true}
                        className={classes.inputStyle}
                        label={t('order.reason')}
                        id='reason'
                        name='reason'
                        value={reason}
                        onChange={(e: any) => setReason(e.target.value)}
                        variant='outlined'
                        select
                      >
                        {reasons.map((r: any, index: number) => {
                          return (
                            <MenuItem key={index} value={r}>
                              {r}
                            </MenuItem>
                          );
                        })}
                      </BccInput>
                    </Grid>
                    <Grid item>
                      <Grid
                        container
                        justify='flex-start'
                        wrap='nowrap'
                        className={classes.checkboxText}
                        style={{ marginBottom: 24 }}
                      >
                        <Grid item>
                          <BccCheckbox
                            value='remember'
                            color='primary'
                            checked={agreeWp}
                            onChange={() => setAgreeWp(!agreeWp)}
                          />
                        </Grid>
                        <Grid item>
                          <BccTypography onClick={() => setAgreeWp(!agreeWp)} type='p3' ml='10px'>
                            {t('order.wpCheck')}{' '}
                            <a href={process.env.PUBLIC_URL + '/conditions.pdf'} target='_blank'>
                              {t('order.wpCheck1')}
                            </a>
                          </BccTypography>
                        </Grid>
                      </Grid>
                    </Grid>
                    {agreeWp && (
                      <Grid item>
                        <BccInput
                          className={classes.inputStyle}
                          fullWidth
                          label={t('order.wp')}
                          variant='filled'
                          id='wp'
                          name='wp'
                          value={wp}
                          onChange={(e: any) => setWp(e.target.value)}
                        />
                      </Grid>
                    )}
                    <Grid item>
                      <BccTypography type='h6' align='left' mb='12px' color='#4D565F' block>
                        {t('order.chooseDoc')}:
                      </BccTypography>
                    </Grid>
                    <Grid
                      item
                      container
                      justify='space-between'
                      wrap='nowrap'
                      className={classes.docForm}
                    >
                      <Grid item>
                        <BccTypography type='p3' color='#4D565F' mb='4px' block>
                          {t('order.doc')}
                        </BccTypography>
                        <BccTypography type='p4' color='#80868C' block>
                          {t('order.docDesc')}
                        </BccTypography>
                        {file1Error && (
                          <BccTypography type='p4' mt='4px' color='#C84F4F' block>
                            {t('order.docError')}
                          </BccTypography>
                        )}
                      </Grid>
                      <Grid item>
                        <BccButton
                          variant='outlined'
                          color='secondary'
                          component='span'
                          size='small'
                          className={classes.btnStyle}
                          style={{ color: file1 ? '#27AE60' : '' }}
                        >
                          {file1 ? t('order.fileChoosed') : t('order.fileNotChoosed')}
                          <input
                            className={classes.file}
                            type='file'
                            onChange={(e) => handleChange(e, 0)}
                            accept='image/png, image/jpeg, image/gif, application/pdf'
                          />
                        </BccButton>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <BccButton
                        variant='contained'
                        disabled={!isValid()}
                        onClick={() => startProcess()}
                        color='primary'
                        fullWidth
                      >
                        {t('order.sendOrder')}
                      </BccButton>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item style={{ marginBottom: 24 }}>
                      <BccAlert severity='error'>
                        <BccTypography type='p3' align='left'>
                          {t('order.notice1')}
                        </BccTypography>
                      </BccAlert>
                    </Grid>
                    <Grid item style={{ marginBottom: 24 }}>
                      <BccAlert severity='error'>
                        <BccTypography type='p3' align='left'>
                          {t('order.notice2')}
                        </BccTypography>
                      </BccAlert>
                    </Grid>
                    {type === '1' && subType === '1' && (
                      <Grid item style={{ marginBottom: 24 }}>
                        <BccAlert severity='error'>
                          <BccTypography type='p3' align='left'>
                            {t('order.notice3')}
                          </BccTypography>
                        </BccAlert>
                      </Grid>
                    )}
                    <Grid item>
                      <BccInput
                        fullWidth={true}
                        className={classes.inputStyle}
                        label={t('order.finin') + '*'}
                        id='sloan'
                        name='sloan'
                        value={sloan.map((s) => s).join(', ')}
                        variant='outlined'
                        select
                      >
                        <MenuItem key='0' value='0'></MenuItem>
                        {sloan.length > 1 && (
                          <MenuItem key='-2' value={sloan.map((s) => s).join(', ')}>
                            {sloan.map((s) => s).join(', ')}
                          </MenuItem>
                        )}
                        {(loans as Loan[])
                          // .filter((l: Loan) =>
                          //   typeCli.length > 0 ? l.type_cli === typeCli : true,
                          // )
                          .map((l: Loan, i: number) => (
                            <MenuItem
                              key={i}
                              value={l.acc_nickname2}
                              onClick={() =>
                                sloan.filter((s) => s === '-1').length > 0
                                  ? setSloan([...sloan.filter((s) => s !== '-1'), l.acc_nickname2])
                                  : sloan.filter((s) => s === l.acc_nickname2).length > 0
                                  ? setSloan([...sloan.filter((s) => s !== l.acc_nickname2)])
                                  : setSloan([...sloan, l.acc_nickname2])
                              }
                            >
                              <BccCheckbox
                                value='remember'
                                color='primary'
                                checked={sloan.filter((s) => s === l.acc_nickname2).length > 0}
                                onChange={() =>
                                  sloan.filter((s) => s === '-1').length > 0
                                    ? setSloan([
                                        ...sloan.filter((s) => s !== '-1'),
                                        l.acc_nickname2,
                                      ])
                                    : sloan.filter((s) => s === l.acc_nickname2).length > 0
                                    ? setSloan([...sloan.filter((s) => s !== l.acc_nickname2)])
                                    : setSloan([...sloan, l.acc_nickname2])
                                }
                              />
                              {`${l.acc_nickname} ${l.acc_nickname2}`}
                              {/* от ${l.loan_date} ${l.loan_name} ${l.loan_sum} KZT`}{" "} */}
                              {/* <span
                                style={{
                                  color: "#27AE60",
                                  margin: "0 0 0 20px",
                                }}
                              >
                                {l.loan_status}
                              </span> */}
                            </MenuItem>
                          ))}
                        <MenuItem key='-1' value='-1' onClick={() => setSloan(['-1'])}>
                          {t('order.fin')}
                        </MenuItem>
                      </BccInput>
                    </Grid>
                    <Grid item>
                      <BccInput
                        className={classes.inputStyleText}
                        fullWidth
                        label={t('order.text') + '*'}
                        variant='filled'
                        id='other'
                        name='other'
                        multiline
                        value={other}
                        onChange={(e: any) => setOther(e.target.value)}
                      />
                    </Grid>
                    {type === '1' && subType === '2' && (
                      <Grid item>
                        <BccInput
                          className={classes.inputStyleText}
                          fullWidth
                          label={t('order.type1sum') + '*'}
                          variant='filled'
                          id='type1sum'
                          name='type1sum'
                          value={type1sum}
                          onChange={(e: any) => setType1sum(e.target.value)}
                        />
                      </Grid>
                    )}
                    {type === '1' && (subType === '3' || subType === '4') && (
                      <Grid item>
                        <BccInput
                          className={classes.inputStyleText}
                          fullWidth
                          label={t('order.type1num')}
                          variant='filled'
                          id='type1num'
                          name='type1num'
                          value={type1num}
                          onChange={(e: any) => setType1num(e.target.value)}
                        />
                      </Grid>
                    )}
                    {type === '1' && (subType === '3' || subType === '4') && (
                      <Grid item>
                        <BccInput
                          className={classes.inputStyleText}
                          fullWidth
                          label={t('order.type1date') + '*'}
                          variant='filled'
                          id='type1date'
                          name='type1date'
                          value={type1date}
                          onChange={(e: any) => setType1date(e.target.value)}
                        />
                      </Grid>
                    )}
                    <Grid item>
                      <Grid
                        container
                        justify='flex-start'
                        wrap='nowrap'
                        className={classes.checkboxText}
                        style={{ marginBottom: 24 }}
                      >
                        <Grid item>
                          <BccCheckbox
                            value='remember'
                            color='primary'
                            checked={agreeThird}
                            onChange={() => setAgreeThird(!agreeThird)}
                          />
                        </Grid>
                        <Grid item>
                          <BccTypography
                            onClick={() => setAgreeThird(!agreeThird)}
                            type='p3'
                            ml='10px'
                          >
                            {t('order.third')}
                          </BccTypography>
                        </Grid>
                      </Grid>
                    </Grid>
                    {agreeThird && (
                      <Grid item>
                        <BccInput
                          className={classes.inputStyle}
                          fullWidth
                          label={t('order.iinMain') + '*'}
                          variant='filled'
                          id='iin-main'
                          name='iin-main'
                          value={iinMain}
                          onChange={(e: any) => {
                            setIinMain(e.target.value.replace(/\D/g, '').substr(0, 12));
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            inputComponent: BccMaskedIinInput as any,
                          }}
                        />
                      </Grid>
                    )}
                    <Grid item>
                      <Grid
                        container
                        justify='flex-start'
                        wrap='nowrap'
                        className={classes.checkboxText}
                        style={{ marginBottom: 24 }}
                      >
                        <Grid item>
                          <BccCheckbox
                            value='remember'
                            color='primary'
                            checked={agreeFa}
                            onChange={() => setAgreeFa(!agreeFa)}
                          />
                        </Grid>
                        <Grid item>
                          <BccTypography onClick={() => setAgreeFa(!agreeFa)} type='p3' ml='10px'>
                            {t('order.factAddress')}
                          </BccTypography>
                        </Grid>
                      </Grid>
                    </Grid>
                    {agreeFa && (
                      <Grid item>
                        <BccInput
                          className={classes.inputStyle}
                          fullWidth
                          label={t('order.factAddressHint') + '*'}
                          variant='filled'
                          id='fa'
                          name='fa'
                          value={fa}
                          onChange={(e: any) => setFa(e.target.value)}
                        />
                      </Grid>
                    )}
                    <Grid item>
                      <Grid
                        container
                        justify='flex-start'
                        wrap='nowrap'
                        className={classes.checkboxText}
                        style={{ marginBottom: 24 }}
                      >
                        <Grid item>
                          <BccCheckbox
                            value='remember'
                            color='primary'
                            checked={agreeWp}
                            onChange={() => setAgreeWp(!agreeWp)}
                          />
                        </Grid>
                        <Grid item>
                          <BccTypography onClick={() => setAgreeWp(!agreeWp)} type='p3' ml='10px'>
                            {t('order.wpCheck')}{' '}
                            <a href={process.env.PUBLIC_URL + '/conditions.pdf'} target='_blank'>
                              {t('order.wpCheck1')}
                            </a>
                          </BccTypography>
                        </Grid>
                      </Grid>
                    </Grid>
                    {agreeWp && (
                      <Grid item>
                        <BccInput
                          className={classes.inputStyle}
                          fullWidth
                          label={t('order.wp')}
                          variant='filled'
                          id='wp'
                          name='wp'
                          value={wp}
                          onChange={(e: any) => setWp(e.target.value)}
                        />
                      </Grid>
                    )}
                    <Grid item>
                      <BccTypography type='h6' align='left' mb='12px' color='#4D565F' block>
                        {type !== '13' ? t('order.chooseDoc') : t('order.doc')}:
                      </BccTypography>
                    </Grid>
                    <Grid
                      item
                      container
                      justify='space-between'
                      wrap='nowrap'
                      className={classes.docForm}
                    >
                      <Grid item>
                        <BccTypography type='p3' color='#4D565F' mb='4px' block>
                          {t('order.doc')}
                        </BccTypography>
                        <BccTypography type='p4' color='#80868C' block>
                          {t('order.docDesc')}
                        </BccTypography>
                        {file1Error && (
                          <BccTypography type='p4' mt='4px' color='#C84F4F' block>
                            {t('order.docError')}
                          </BccTypography>
                        )}
                      </Grid>
                      <Grid item>
                        <BccButton
                          variant='outlined'
                          color='secondary'
                          component='span'
                          size='small'
                          className={classes.btnStyle}
                          style={{ color: file1 ? '#27AE60' : '' }}
                        >
                          {file1 ? t('order.fileChoosed') : t('order.fileNotChoosed')}
                          <input
                            className={classes.file}
                            type='file'
                            onChange={(e) => handleChange(e, 0)}
                            accept='image/png, image/jpeg, image/gif, application/pdf'
                          />
                        </BccButton>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <BccButton
                        variant='contained'
                        disabled={!isValid()}
                        onClick={() => startProcess()}
                        color='primary'
                        fullWidth
                      >
                        {t('order.sendOrder')}
                      </BccButton>
                    </Grid>
                  </>
                )
              ) : success ? (
                <Grid item>
                  <div className={classes.successForm}>
                    <img src={process.env.PUBLIC_URL + '/img/success.svg'} alt='' />
                    <BccTypography type='h6' color='#1F7042' mb='16px'>
                      {t('order.success')}
                    </BccTypography>
                    <BccTypography type='p2' color='#1F7042' mb='16px'>
                      {t('order.successDesc')}
                    </BccTypography>
                    {new Date().getUTCHours() + 6 >= 18 && (
                      <BccTypography type='p2' color='#1F7042'>
                        {t('order.successDescTime')}
                      </BccTypography>
                    )}
                  </div>
                </Grid>
              ) : (
                <Grid item>
                  <div className={classes.errorForm}>
                    <img src={process.env.PUBLIC_URL + '/img/error.svg'} alt='' />
                    <BccTypography type='h6' color='initial' mb='16px'>
                      {t('order.error')}
                    </BccTypography>
                    <BccTypography type='p2' color='initial'>
                      {t('order.errorDesc')}
                    </BccTypography>
                  </div>
                </Grid>
              )}
            </BlockUi>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default Order;
